import { useQuery } from "@tanstack/react-query";
import { getAccessContacts } from "../api/rbac-api";
import type { AccessContactPage } from "../types/RolesPermissions.type";

export const ACCESS_CONTACTS_KEY = ["rbac", "me", "access-contacts"] as const;

/**
 * PRO-737 — the System Admins and Leads in the caller's own company, to contact
 * about getting permissions.
 *
 * Server-paginated five at a time rather than fetched whole and sliced: a large
 * company can hold dozens of admins, and this is rendered to a user with no
 * standing, so the payload is kept as small as the view actually needs.
 *
 * `placeholderData` keeps the previous page on screen while the next one loads,
 * so paging and typing do not blank the table between keystrokes.
 */
export const useAccessContacts = (search: string, page: number) =>
	useQuery<AccessContactPage>({
		queryKey: [...ACCESS_CONTACTS_KEY, search, page],
		queryFn: () => getAccessContacts({ search, page }),
		placeholderData: (previous) => previous,
		staleTime: 5 * 60 * 1000,
	});
